import { graphql } from '@/gql';
import type { ReferralsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchReferrals = async ({ phoneNumber, referralCode, pagination }: ReferralsQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query Referrals($phoneNumber: String, $referralCode: String, $pagination: PaginationInputType) {
        referrals(phoneNumber: $phoneNumber, referralCode: $referralCode, pagination: $pagination) {
          count
          rows {
            id
            referrerId
            refereeId
            promoId
            referralCode
            source
            referrer {
              id
              firstName
              lastName
              phoneNumber
              homeNumber
              phoneNumber2
            }
            referee {
              id
              firstName
              lastName
              phoneNumber
              homeNumber
              phoneNumber2
            }
            createdAt
            updatedAt
          }
        }
      }
    `),
    variables: {
      phoneNumber,
      referralCode,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.referrals!;
};
